import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { range } from 'rxjs';

@Component({
	selector: 'pager',
	templateUrl: './pager.component.html',
	styleUrls: ['./pager.component.scss']
})
export class PaginationComponent implements OnInit {

	@Input() initialPage = 1;
	@Input() current_page: number;
	@Input() last_page: number;
	@Output() changePage = new EventEmitter<any>(true);

	constructor() { }

	ngOnInit(): void {}

	get pages(): number[]{
		const pages = [];
		for (let i = this.initialPage; i <= this.last_page; i++) pages.push(i);
		return pages;
	}

	setPage(page: number): void {
		// call change page function in parent component
		this.changePage.emit(page);
	}
}
